import { render, staticRenderFns } from "./AkDatePreview.vue?vue&type=template&id=0d997d92&"
import script from "./AkDatePreview.vue?vue&type=script&lang=js&"
export * from "./AkDatePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/htdocs/ligo/src/vue-apps/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d997d92')) {
      api.createRecord('0d997d92', component.options)
    } else {
      api.reload('0d997d92', component.options)
    }
    module.hot.accept("./AkDatePreview.vue?vue&type=template&id=0d997d92&", function () {
      api.rerender('0d997d92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "widgets/AkDatePreview.vue"
export default component.exports